export default "__VITE_ASSET__QVIDrE11__"